module.exports = __webpack_public_path__ + "img/brand-title.5553135.png";